import Show from '../show'

function WorkflowPendingDashboard() {
  return (
    <Show
      title="Pending Workflow Dashboard"
      dashboardKey="workflow_pending_dashboards"
      showYear={false}
      showAccounts={false}
      showEmployee={false}
      showVendor={false}
      showAnalytics={false}
    />
  )
}

export default WorkflowPendingDashboard
